const incomingCall = {
  content: 'Toast-Incoming-Call-Content',
  acceptButton: 'Toast-Incoming-Call-AcceptButton',
  rejectButton: 'Toast-Incoming-Call-RejectButton',
};

export const toastlocators = {
  incomingCall,
};
